import { useContext } from "react";
import { IRuntimeConfig } from "@finbackoffice/fe-core";
import { RuntimeConfigContext } from "../providers";

export function useRuntimeConfig<T extends keyof IRuntimeConfig>(key: T) {
    const context = useContext(RuntimeConfigContext);
    return context[key];
}
